export default __webpack_public_path__ + "static/media/coffee-cup.9a4bce9e.svg";